<template>
  <v-app>
    <layout v-if="setLayout"></layout>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import layout from "./modules/layout/page/layout.vue";
export default {
  name: "App",
  components: {
    layout,
  },

  data: () => ({
    routerFlag: "",
  }),
  watch: {
    $route: {
      immediate: true,
      handler() {
        if (this.$route.path == "/forecast-tool") {
          this.routerFlag = "forecast-tool";
        } else if (this.$route.path == "/consensus-report") {
          this.routerFlag = "consensus-report";
        } else if (this.$route.path == "/historical-data-visualization") {
          this.routerFlag = "historical-data-visualization";
        } else if (this.$route.path == "/home") {
          this.routerFlag = "home";
        }
      },
    },
  },
  computed: {
    ...mapGetters(["isAuth"]),
    setLayout() {
      let flag = true;
      if (
        this.$route.path == "/login" ||
        this.$route.path == "/register" ||
        this.$route.path == "/recovery" ||
        this.$route.path == "/register-success" ||
        this.$route.path.includes("/activation-user/")
      ) {
        flag = false;
      }
      return flag;
    },
  },
  mounted() {
    console.log(this.isAuth);
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Open+Sans");

@font-face {
  font-family: "Open Sans";
  src: local("OpenSans"),
    url(./assets/fonts/OpenSans-Regular.ttf) format("truetype");
}
body {
  background: var(--bg-2);
}
</style>
